export default "__VITE_ASSET__239f5d07__"